import moment from "moment";

const defaultValues = {
    startDate : "",
    endDate : "",
    statusSelection :  {
        "label": "Open",
        "value": 0,
        "associatedId": 0,
    },
    processStatusDesc: "",
    list: [],
}

const poReducer = (state=defaultValues, action)=>{
    if(action.type === "BEFORE_PO"){
        return state = {...state,...action.payload};
    }
    return state;
};

export default poReducer;